<template>
  <v-container fluid grid-list-xl>
    <v-layout row justify-center wrap>
      <v-flex lg6 sm9 xs12>
        <transition name="fade" mode="out-in">
          <div>
            <v-switch
              v-if="auth.role === 'Administrador'"
              :label="labels.autorizado"
              v-model="autorizado"
              @change="changeEstado"
              :disabled="programa.estado === 'conflicto-carrera'"
            ></v-switch>

            <v-text-field
              :label="labels.estado"
              :value="programa.estado === 'no_autorizado' ? labels.mensaje_no_autorizado : (programa.estado === 'autorizado' ? labels.mensaje_autorizado : labels.mensaje_conflicto_carrera)"
              outline
              readonly
            ></v-text-field>

            <v-text-field
              :label="labels.campus"
              v-model="programa.campus"
              @click:append="editarPrograma('campus')"
              :append-icon="programa.estado === 'no_autorizado' ? 'edit' : ''"
              outline
              readonly
            ></v-text-field>

            <v-text-field
              :label="labels.carrera"
              v-model="programa.carrera"
              @click:append="editarPrograma('carrera')"
              :append-icon="(programa.estado === 'no_autorizado' || programa.estado === 'conflicto-carrera') ? 'edit' : ''"
              outline
              readonly
            ></v-text-field>
        
            <v-text-field
              :label="labels.modalidad"
              v-model="programa.modalidad"
              @click:append="editarPrograma('modalidad')"
              :append-icon="programa.estado === 'no_autorizado' ? 'edit' : ''"
              outline
              readonly
            ></v-text-field>

            <v-text-field
              :label="labels.tipo_periodo"
              v-model="programa.tipo_periodo"
              @click:append="editarPrograma('tipo_periodo')"
              :append-icon="programa.estado === 'no_autorizado' ? 'edit' : ''"
              outline
              readonly
            ></v-text-field>
          
            <v-text-field
              :label="labels.tipo_rvoe"
              v-model="programa.tipo_rvoe"
              @click:append="editarPrograma('tipo_rvoe')"
              :append-icon="programa.estado === 'no_autorizado' ? 'edit' : ''"
              outline
              readonly
            ></v-text-field>
          
            <v-text-field
              :label="labels.numero_rvoe"
              v-model="programa.numero_rvoe"
              @click:append="editarPrograma('numero_rvoe')"
              :append-icon="programa.estado === 'no_autorizado' ? 'edit' : ''"
              outline
              readonly
            ></v-text-field>
          
            <v-text-field
              :label="labels.fecha_rvoe"
              v-model="programa.fecha_rvoe"
              @click:append="editarPrograma('fecha_rvoe')"
              :append-icon="programa.estado === 'no_autorizado' ? 'edit' : ''"
              outline
              readonly
            ></v-text-field>
        
            <v-text-field
              :label="labels.clave_plan"
              v-model="programa.clave_plan"
              @click:append="editarPrograma('clave_plan')"
              :append-icon="programa.estado === 'no_autorizado' ? 'edit' : ''"
              outline
              readonly
            ></v-text-field>
          
            <v-text-field
              :label="labels.calificacion_maxima"
              v-model="programa.calificacion_maxima"
              @click:append="editarPrograma('calificacion_maxima')"
              :append-icon="programa.estado === 'no_autorizado' ? 'edit' : ''"
              outline
              readonly
            ></v-text-field>
          
            <v-text-field
              :label="labels.calificacion_minima"
              v-model="programa.calificacion_minima"
              @click:append="editarPrograma('calificacion_minima')"
              :append-icon="programa.estado === 'no_autorizado' ? 'edit' : ''"
              outline
              readonly
            ></v-text-field>
          
            <v-text-field
              :label="labels.calificacion_minima_aprobatoria"
              v-model="programa.calificacion_minima_aprobatoria"
              @click:append="editarPrograma('calificacion_minima_aprobatoria')"
              :append-icon="programa.estado === 'no_autorizado' ? 'edit' : ''"
              outline
              readonly
            ></v-text-field>
          </div>
        </transition>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'
  import { api } from '~/config'
  import Form from '~/mixins/form'

  export default {
    mixins: [Form],

    data: () => ({
      loading: false,

      programa: {},
      autorizado: null
    }),

    computed: {
      ...mapGetters({
        live_mode: "auth/live_mode",
        auth: 'auth/user',
      })
    },

    watch: {
      live_mode(val) {
        if (val !== undefined) {
          this.$router.push({ name: 'programa' })
        }
      }
    },

    mounted() {
      this.getPrograma()
    },

    methods: {
      getPrograma(id) {
        axios.get(api.path('programas.single', { id: this.$route.params.id } ))
          .then(res => {
            this.programa = res.data
            if (this.programa.estado === 'autorizado') {
              this.autorizado = true
            }
          })
          .catch(err => {
            this.handleErrors(err.response.data.errors)
          })
          .then(() => {})
      },

      changeEstado() {
        axios
          .put(api.path('programas.single', { id: this.$route.params.id }), {
            estado: this.autorizado ? 'autorizado' : 'no_autorizado'
          })
          .then(res => {
            this.getPrograma()
            this.$toast.success('Se actualizó el estado del programa.')
          })
          .catch(err => {
            this.handleErrors(err.response.data.errors)
          })
          .then(() => {
          })
      },

      editarPrograma(campo) {
        this.$router.push({ name: "programa-editar", params: { 'campo': campo } })
      }
    }
  }
</script>
